module.exports = __webpack_public_path__ + "img/Status-Server Monitor-Report-Up-2.63505b74.svg";